import type { MileageErrors } from './mileageCostOptionsTypes';

export type ValidationResult = {
    isValid: boolean;
    error?: string;
};

export const validateMilesAtInception = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true }; // Don't validate empty values, let required field validation handle it
    }

    if (numValue < 0) {
        return { isValid: false, error: 'Miles at inception must be >= 0' };
    }

    return { isValid: true };
};

export const validateThresholdMiles = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true };
    }

    if (numValue < 0) {
        return { isValid: false, error: 'Threshold miles must be >= 0' };
    }

    return { isValid: true };
};

export const validateRetroMiles = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true };
    }

    if (numValue < 0) {
        return { isValid: false, error: 'Retro miles must be >= 0' };
    }

    return { isValid: true };
};

export const validateInceptionRate = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true };
    }

    if (numValue < 0) {
        return { isValid: false, error: 'Inception rate must be >= 0' };
    }

    return { isValid: true };
};

export const validateStandardAllowedMiles = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true };
    }

    if (numValue <= 0) {
        return { isValid: false, error: 'Standard allowed miles must be > 0' };
    }

    return { isValid: true };
};

export const validateAnnualMiles = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true };
    }

    if (numValue <= 0) {
        return { isValid: false, error: 'Annual miles must be > 0' };
    }

    return { isValid: true };
};

export const validateExcessMileRate = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true };
    }

    if (numValue < 0) {
        return { isValid: false, error: 'Excess mile rate must be >= 0' };
    }

    return { isValid: true };
};

export const validateMileagePenaltyRate = (value: string | number | null): ValidationResult => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (value === null || value === '' || numValue === null || isNaN(numValue as number)) {
        return { isValid: true };
    }

    if (numValue < 0) {
        return { isValid: false, error: 'Mileage penalty rate must be >= 0' };
    }

    return { isValid: true };
};

export const hasValidationErrors = (errors: MileageErrors): boolean => {
    return Object.values(errors).some((error) => !!error);
};
